import type { IEpochStore } from "@/domains/epochs/interfaces"
import {
  formatEpochDate,
  formatEpochInteger,
  formatEpochPercentage,
} from "@/domains/epochs/utils/epoch-formatters"
import { VerticalTable } from "@/components/vertical-table"

export interface CurrentEpochSidePanelProps {
  currentEpoch: IEpochStore | undefined
}

export function CurrentEpochSidePanel({ currentEpoch }: CurrentEpochSidePanelProps) {
  if (!currentEpoch) {
    return (
      <div className="h-full rounded-lg border border-p400-light bg-p400 px-6 py-8 text-t100">
        <div className="flex h-full min-h-[200px] w-full items-center justify-center">
          <div className="text-t200">No current epoch data available</div>
        </div>
      </div>
    )
  }

  const rows = [
    {
      label: "Date",
      value: formatEpochDate(currentEpoch.startTimestamp),
    },
    {
      label: "Fresh",
      value: formatEpochInteger(currentEpoch.mints),
    },
    {
      label: "Fresh %",
      value: formatEpochPercentage(currentEpoch.freshPercentage),
    },
    {
      label: "Recycled",
      value: formatEpochInteger(currentEpoch.recycled),
    },
    {
      label: "Recycled %",
      value: formatEpochPercentage(currentEpoch.recycledPercentage),
    },
    {
      label: "Total Emitted",
      value: formatEpochInteger(currentEpoch.gaugesMint),
    },
    {
      label: "BPG",
      value: "0",
    },
    {
      label: "Effective Total",
      value: formatEpochInteger(currentEpoch.gaugesMint),
    },
  ]

  return (
    <div className="h-full rounded-lg border border-p400-light bg-p400 px-6 py-8 text-t100">
      <h2 className="text-center text-2xl font-bold text-t100 py-8">Epoch {currentEpoch.epochNumber}</h2>
      <VerticalTable rows={rows} />
    </div>
  )
}
